// removed by extract-text-webpack-plugin
module.exports = {"loginModal":"loginModal_1EBPY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/index.scss
// module id = 147
// module chunks = 15